module.exports = __webpack_public_path__ + "static/media/drlicita-menu.a15618ea.svg";